/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1617
 */

require(/* 759 */"./1707/759")("Array")
